/* global google */
import React, { useState, useEffect, useRef } from 'react';
import ReactApexChart from 'react-apexcharts';
import styles from "./index.module.scss"

export const TimelineChart = ({ bins, vehicleLocation, hide, zones, isTimelineChartVisible, setTimelineChartVisible, buttonTop, setButtonTop }) => {
    const [series, setSeries] = useState([]);
    const zoneIdToName = {};
    const zoneNames = [];
    for (const zone of zones) {
        zoneIdToName[zone.id] = zone.name;
        zoneNames.push(zone.name)
    }

    const toggleChart = () => {
        setTimelineChartVisible(!isTimelineChartVisible);
        setButtonTop(isTimelineChartVisible ? '2px' : '10px');
      };
    
    useEffect(() => {
        if (!vehicleLocation || Object.keys(vehicleLocation).length === 0 || !bins || bins.length === 0) {
            setSeries([])
            return;
        }
        
        const fetchData = async () => {
            // Group bins by zone.
            const binsByZone = bins.reduce((groups, bin) => {
                const zone = bin.zone;
                if (!groups[zone]) {
                    groups[zone] = [];
                }
                groups[zone].push(bin);
                return groups;
            }, {});
            const newSeries = [];
            
            for (const zone in binsByZone) {
                // Sort bins in the same zone by time.
                binsByZone[zone].sort((a, b) => a.time - b.time);
                let now = new Date();
                let startTime = now.getUTCHours() * 60 + now.getUTCMinutes(); // get the current time in minutes
                for (const bin of binsByZone[zone]) {
                    if (typeof vehicleLocation.latitude !== 'number' || typeof vehicleLocation.longitude !== 'number') {
                        console.error('Invalid vehicle location:', vehicleLocation);
                        return;
                    }
                    const origin = { lat: vehicleLocation.latitude, lng: vehicleLocation.longitude };
                    const destination = { lat: parseFloat(bin.latitude), lng: parseFloat(bin.longitude) };
                    const { distance, time } = await calculateDistanceAndTime(origin, destination);
                    const timeInMinutes = parseInt(time.split(' ')[0]);
                    newSeries.push({
                        x: zoneIdToName[zone],
                        y: [
                            Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 0, startTime),
                            Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), 0, startTime + timeInMinutes)
                        ],
                        z: distance,
                        a: bin.address
                    });
                    startTime += timeInMinutes;
                }
            }
            setSeries([{ data: newSeries }]);
        };
                

        fetchData();
    }, [bins, vehicleLocation]);
        

    const calculateDistanceAndTime = (origin, destination) => {
        return new Promise((resolve, reject) => {
          const service = new google.maps.DistanceMatrixService();
          service.getDistanceMatrix(
            {
                origins: [origin],
                destinations: [destination],
                travelMode: 'DRIVING',
            },
            (response, status) => {
                if (status !== 'OK') {
                    console.error('Error was: ' + status);
                    reject(status);
                } else {
                    const results = response.rows[0].elements;
                    const distance = results[0].distance.text; // Distance in meters
                    const time = results[0].duration.text; // Time in seconds
                    resolve({ distance, time });
                }
            }
        );
    });}; 

    const options = {
        chart: {
            height: 150,
            type: 'rangeBar',
            toolbar: {
                show: false
            },
            width: '100%',
            background: '#ffffff'
        },
        plotOptions: {
            bar: {
                horizontal: true,
                distributed: true,
                dataLabels: {
                    hideOverflowingLabels: false
                },
            }
        },
        dataLabels: {
            enabled: true,
            formatter: function(val, opts) {
                var a = new Date(val[0]);
                var b = new Date(val[1]);
                var diff = Math.abs(a - b);
                var duration = diff/(1000*60) + (diff/(1000*60) > 1 ? ' minutes' : ' minute');
                var distance = opts.w.globals.seriesZ[opts.seriesIndex][opts.dataPointIndex]; // get the distance
                return duration + ', ' + distance;
            },
            style: {
                colors: ['#f3f4f5', '#fff']
            }
        },
        xaxis: {
            type: 'datetime',
            labels: {
                datetimeUTC: false
            },
            // minTickSize: [1, 'minute']
        },
        yaxis: {
            // show: false,
            categories: zoneNames
        },
        grid: {
            row: {
                colors: ['#f3f4f5', '#fff'],
                opacity: 1
            }
        }, tooltip: {
            custom: function({ series, seriesIndex, dataPointIndex, w }) {
                var address = w.config.series[seriesIndex].data[dataPointIndex].a; // get the bin address
                return '<div>' + address + '</div>'; // display the bin address
            }                      
        }
    };

    return (
        series.length > 0 ? (
            <div className={`${styles.container} ${hide ? styles.hide : ""}`}>
                <div className={styles.buttonContainer} style={{ top: buttonTop }}>
                    <button className={styles.button} onClick={toggleChart}>
                        {isTimelineChartVisible ? 'Hide ▼' : 'Show ▲'}
                    </button>
                </div>
                {isTimelineChartVisible && (
                    <ReactApexChart options={options} series={series} type="rangeBar" height={150} />
                )}
            </div>
        ) : null
    );
    
       
};